
import "../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_224_0_Accordion";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_224_0_Accordion__root","accordion":"wds_1_224_0_Accordion__accordion","item":"wds_1_224_0_Accordion__item"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-accordion-border-radius":"--wds-accordion-border-radius","wds-accordion-background-fill-light":"--wds-accordion-background-fill-light"}; 




